import PropTypes from 'prop-types'
import cn from '../modules/cn'
import propTypeDeprecation from '../modules/propTypeDeprecation'

function Icon({
  children,
  shaded,
  fontSize,
  className,
}) {
  const baseStyle = cn(
    'block fill-current',
    fontSize && `text-[${fontSize}]`,
    'w-[1em] h-[1em]',
    className,
  )

  if (shaded) {
    return (
      <div className="p-2 box-border bg-theme-50 rounded-full">
        <div className="p-1 box-border bg-theme-500 rounded-full flex justify-center items-center text-white">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className={baseStyle}
            viewBox="0 0 24 24"
          >
            {children}
          </svg>
        </div>
      </div>
    )
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={baseStyle}
      viewBox="0 0 24 24"
    >
      {children}
    </svg>
  )
}

Icon.propTypes = {
  children: PropTypes.node.isRequired,
  shaded: PropTypes.bool,
  fontSize: propTypeDeprecation(PropTypes.string),
  className: cn.propType,
}

Icon.defaultProps = {
  shaded: false,
  fontSize: null,
  className: null,
}

export default Icon
